import { gql } from '@apollo/client'

const DISH_MAIN_INGREDIENT_FRAGMENT = gql`
  fragment DishMainIngredientFragment on DishMainIngredient {
    ingredient {
      id
      name
      isCurationEnabled
    }
    originField
    word
    matchType
    isSuggestedByAi
    alternativeType
    replacesIngredientId
    usedFeature
    posIndex
    isSuggestedUsingMl
    isSuggestedUsingParser
    mlScore
    isDiscrepancyAccepted
    overrides {
      word
      originField
      posIndex
    }
    alreadyFoundIn {
      word
      originField
      posIndex
      matchType
      usedFeature
    }
  }
`
export default DISH_MAIN_INGREDIENT_FRAGMENT
